import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
		showSearchBox: false,
		showTeleBox: false,
		showSettings: false,
	},
	computed: {
		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		},

		phoneView: function () {
			if (VOFFICE.phoneView) {
				return VOFFICE.phoneView;
			}
		},

	},

	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});
		this.initDropdownEventListeners();
		document
			.querySelectorAll(".dropdown-submenu .dropdown-toggle")
			.forEach(function (element) {
				element.addEventListener("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					this.nextElementSibling.classList.toggle("show");
				});
			});
	},

	methods: {
		scrollToTop: function () {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		},

		toggleFontSize: function () {
			var largefont = document.body.classList.contains("largefont");
			var suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			if (largefont) {
				document.body.classList.remove("largefont");
				localStorage.setItem("fontsize_" + suffix, "normal");
			} else {
				document.body.classList.add("largefont");
				localStorage.setItem("fontsize_" + suffix, "large");
			}
		},
		toggleViewMode: function () {
			var darkModeEnabled = document.body.classList.contains("dark");
			var suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			if (darkModeEnabled) {
				document.body.classList.remove("dark");
				localStorage.setItem("viewMode_" + suffix, "light");
			} else {
				document.body.classList.add("dark");
				localStorage.setItem("viewMode_" + suffix, "dark");
			}
		},
		toggleSearchbox: function (event) {
			this.showSearchBox = !this.showSearchBox;
		},
		toggleTelebox: function (event) {
			this.showTeleBox = !this.showTeleBox;
		},
		toggleSettings: function (event) {
			this.showSettings = !this.showSettings;
		},

		phoneLink: function () {
			if (VOFFICE.phoneLink) {
				var el = document.getElementById('preloader');
				window.location.href = VOFFICE.phoneLink;
				if (el) {
					el.style.display = "none";
				}
			}
		},

		navbarToggle: function () {
			$('.main-menu').slideToggle();
			$('.navbar-v1').removeClass('open-by-mob');
			this.showTeleBox = false;
			this.showSearchBox = false;
		},

		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		},
		toggleDropdownOnEnter: function (event) {
			if (event.keyCode === 13) {
				event.preventDefault();

				// Ensure the event is triggered only for elements with .dropdown-toggle class
				if (event.target.classList.contains('dropdown-toggle')) {
					var dropdownToggle = event.target;
					var dropdownMenu = dropdownToggle.nextElementSibling;
					var isOpen = dropdownToggle.classList.contains('show');

					if (!isOpen) {
						dropdownToggle.classList.add('show');
						dropdownMenu.classList.add('show');
					}
				}
			}
		},

		initDropdownEventListeners: function () {
			var dropdownToggles = document.querySelectorAll('.dropdown-toggle');
			dropdownToggles.forEach(toggle => {
				toggle.addEventListener('keydown', this.toggleDropdownOnEnter.bind(this));
			});
		},
	}
};